import Query from "../common/Query";
import POSTS_QUERY from "./queries/POSTS_QUERY";
import NewsItem from './components/NewsItem';

const NewsView = () => {
    return <Query query={POSTS_QUERY}>{({ data: { posts } }: { data: { posts: any[] } }) => {
        const els = posts.map((article, i) =>
            <NewsItem article={article} key={article.id} />
        )
        return <div className="articles">
            <h1>News</h1>
            {els}
            </div>;
    }}
    </Query>;
};

export default NewsView;